import axios from 'axios'
import Choices from 'choices.js'
import * as d3 from 'd3'
import html2canvas from 'html2canvas'
import $ from 'jquery'
import 'slick-carousel'
import MediaBox from './coqualMediabox'

MediaBox('.popup-video')

document.addEventListener('keydown', () => {
  document.body.classList.add('is-using-keyboard')
})

document.addEventListener('click', () => {
  document.body.classList.remove('is-using-keyboard')
})

const downloadButtons = document.querySelectorAll('.download button')
const saveAs = (uri, filename) => {
  const link = document.createElement('a')
  if (typeof link.download === 'string') {
    link.href = uri
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else {
    window.open(uri)
  }
}
const handleDownloadButtonClick = async (event) => {
  const slide = event.target.parentElement?.parentElement
  const infoSliderWrap = slide.querySelector('.info-slider-wrap')
  if (infoSliderWrap) {
    const canvas = await html2canvas(infoSliderWrap)
    if (canvas) {
      let filename = 'infographic.png'
      const heading = slide.querySelector('.heading')
      if (heading) {
        filename = `${heading.innerText}.png`
      }
      saveAs(canvas.toDataURL(), filename)
    }
  }
}
for (const downloadButton of downloadButtons) {
  downloadButton.addEventListener('click', handleDownloadButtonClick)
}

const bioModalEl = document.querySelector('.bio-modal')
if (bioModalEl) {
  const pastSpeakerItemEls = document.querySelectorAll(
    '.past-speakers--items--item.is-clickable'
  )
  const closeButtonEl = bioModalEl.querySelector('.close-button')
  const photoEl = bioModalEl.querySelector('.bio-modal--left--photo')
  const nameEl = bioModalEl.querySelector('.bio-modal--right--name')
  const blurbEl = bioModalEl.querySelector('.bio-modal--right--blurb')
  const bioEl = bioModalEl.querySelector('.bio-modal--right--bio')
  const handleBackdropClick = (event) => {
    if (event.target.classList.contains('bio-modal')) {
      handleCloserOrCancelClick()
    }
  }
  const handleCloserOrCancelClick = () => {
    bioModalEl.classList.remove('is-open')
    bioModalEl.removeEventListener('click', handleBackdropClick)
    if (closeButtonEl) {
      closeButtonEl.removeEventListener('click', handleCloserOrCancelClick)
    }
    document.removeEventListener('keydown', handleDocumentKeydown)
    if (photoEl) {
      photoEl.alt = ''
      photoEl.src = ''
    }
    if (nameEl) {
      nameEl.innerHTML = ''
    }
    if (blurbEl) {
      blurbEl.innerHTML = ''
    }
    if (bioEl) {
      bioEl.innerHTML = ''
    }
  }
  const handleDocumentKeydown = (event) => {
    if (event.key === 'Esc' || event.key === 'Escape') {
      handleCloserOrCancelClick()
    }
  }
  const handlePastSpeakerItemElClick = (event) => {
    if (photoEl) {
      const speakerPhotoEl = event.currentTarget.querySelector(
        '.past-speakers--items--item--photo-hover-image--photo'
      )
      if (speakerPhotoEl) {
        photoEl.alt = speakerPhotoEl.alt
        photoEl.src = speakerPhotoEl.src
      }
    }
    if (nameEl) {
      const speakerNameEl = event.currentTarget.querySelector(
        '.past-speakers--items--item--bottom--left--name'
      )
      if (speakerNameEl) {
        nameEl.innerHTML = speakerNameEl.innerHTML
      }
    }
    if (blurbEl) {
      const speakerBlurbEl = event.currentTarget.querySelector(
        '.past-speakers--items--item--bottom--left--blurb'
      )
      if (speakerBlurbEl) {
        blurbEl.innerHTML = speakerBlurbEl.innerHTML
      }
    }
    if (bioEl) {
      const speakerBioEl = event.currentTarget.querySelector(
        '.past-speakers--items--item--bottom--left--bio'
      )
      if (speakerBioEl) {
        bioEl.innerHTML = speakerBioEl.innerHTML
      }
    }
    bioModalEl.classList.add('is-open')
    bioModalEl.addEventListener('click', handleBackdropClick)
    if (closeButtonEl) {
      closeButtonEl.addEventListener('click', handleCloserOrCancelClick)
    }
    document.addEventListener('keydown', handleDocumentKeydown)
  }
  pastSpeakerItemEls.forEach((pastSpeakerItemEl) => {
    pastSpeakerItemEl.addEventListener('click', handlePastSpeakerItemElClick)
  })
}

const hamburger = document.querySelector('.hamburger')
if (hamburger) {
  hamburger.addEventListener('click', () => {
    document.body.classList.remove('search-open')
    document.body.classList.toggle('menu-open')
  })
}

const slideoutMenuWrap = document.querySelector('.slideout-menu-wrap')
if (slideoutMenuWrap) {
  slideoutMenuWrap.addEventListener('mouseleave', () => {
    document.body.classList.remove('menu-open')
  })
  const menuItemsWithChildren = slideoutMenuWrap.querySelectorAll(
    '.menu-item.has-children'
  )
  if (menuItemsWithChildren) {
    menuItemsWithChildren.forEach((menuItemWithChildren) => {
      menuItemWithChildren.addEventListener('mouseover', () => {
        slideoutMenuWrap.classList.add('second-level-is-open')
      })
      menuItemWithChildren.addEventListener('mouseout', () => {
        slideoutMenuWrap.classList.remove('second-level-is-open')
      })
    })
  }
}

const openSearch = document.querySelector('.open-search')
openSearch.addEventListener('click', () => {
  document.body.classList.remove('menu-open')
  document.body.classList.add('search-open')
  const searchForm = document.getElementById('coqual-search-form')
  if (searchForm) {
    searchForm.setAttribute('role', 'dialog')
    searchForm.ariaModal = true
  }
})

const closeSearch = document.querySelector('.close-search')
closeSearch.addEventListener('click', () => {
  document.body.classList.remove('search-open')
  document.body.classList.remove('search')
  document.body.classList.remove('search-no-results')
  document.body.classList.remove('search-results')
  const searchForm = document.getElementById('coqual-search-form')
  if (searchForm) {
    searchForm.removeAttribute('role')
    searchForm.ariaModal = false
  }
})

const signinForm = document.querySelector('#custom-signin-form')
if (signinForm) {
  const inputs = signinForm.querySelectorAll('input')
  if (inputs) {
    inputs.forEach((input) => {
      input.required = true
      if (
        input.previousElementSibling &&
        input.previousElementSibling.tagName == 'LABEL'
      ) {
        input.placeholder = input.previousElementSibling.innerHTML
      }
    })
  }
}

const dateFields = document.querySelectorAll(
  '.wpcf7-form-control-wrap input.datefield'
)
if (dateFields) {
  dateFields.forEach((dateField) => {
    const datePlaceholder = document.createElement('SPAN')
    datePlaceholder.className = 'date-placeholder'
    datePlaceholder.innerText = dateField.placeholder
    dateField.parentElement.appendChild(datePlaceholder)
    dateField.addEventListener('focus', () => {
      dateField.parentElement.classList.add('active')
    })
    dateField.addEventListener('blur', () => {
      let val = dateField.value.trim()
      if (!val) {
        dateField.parentElement.classList.remove('active')
      }
    })
  })
}

// first add raf shim
// http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
// window.requestAnimFrame = (function(){
//     return  window.requestAnimationFrame       ||
//             window.webkitRequestAnimationFrame ||
//             window.mozRequestAnimationFrame    ||
//             function( callback ){
//               window.setTimeout(callback, 1000 / 60);
//             };
//   })();
//   // http://stackoverflow.com/questions/8917921/cross-browser-javascript-not-jquery-scroll-to-top-animation
//   function scrollToY(o,n){function a(){t+=1/60;var n=t/c,l=i(n);1>n?(requestAnimFrame(a),window.scrollTo(0,r+(o-r)*l)):window.scrollTo(0,o)}var r=window.scrollY,o=o||0,n=n||2e3,t=0,c=Math.max(.1,Math.min(Math.abs(r-o)/n,.8)),i=function(o){return-.5*(Math.cos(Math.PI*o)-1)};a()}
//   // active smooth scroll pour les a[href^="#anchor-"]
//   !function() {
//     let el;
//     const _scrollToY = (e) => {
//       e.preventDefault ? e.preventDefault() : (e.returnValue = false);
//       let el = e.target || e.originalTarget || e.srcElement;
//       let name = (el.getAttribute("href") || el.href).slice(1);
//       el = document.getElementsByName(name);
//       if (el.length>0) {
//         scrollToY(el[0].offsetTop, 1500);
//         return false;
//       }
//     }
//     for (var a=document.querySelectorAll('.scrollto-link'), i=0; i<a.length; i++) {
//       el=a[i];
//       if (el.addEventListener){
//         el.addEventListener('click', _scrollToY, false);
//       } else if (el.attachEvent) {
//         el.attachEvent('onclick', _scrollToY);
//       }
//     }
// }();

const scrolltoLinks = document.querySelectorAll('.scrollto-link')
scrolltoLinks.forEach((scrolltoLink) => {
  scrolltoLink.addEventListener('click', (e) => {
    e.preventDefault()
    const targetEl = document.querySelector(scrolltoLink.getAttribute('href'))
    const top_ =
      targetEl.offsetTop -
      document.querySelector('.header-navbar').getBoundingClientRect().height
    window.scrollTo({
      top: top_,
      behavior: 'smooth',
    })
  })
})

const accordionHeaders = document.querySelectorAll('.accordion-header')
accordionHeaders.forEach((accordionHeader) => {
  accordionHeader.addEventListener('click', () => {
    const accordion = accordionHeader.parentElement
    const accordionContent = accordion.querySelector('.accordion-content')
    if (!accordion.classList.contains('open')) {
      accordion.classList.add('open')
      accordionContent.style.height = 'auto'

      /** Get the computed height of the accordion. */
      let height = accordionContent.scrollHeight + 'px'

      /** Set the height of the content as 0px, */
      /** so we can trigger the slide down animation. */
      accordionContent.style.height = '0px'

      /** Do this after the 0px has applied. */
      /** It's like a delay or something. MAGIC! */
      setTimeout(() => {
        accordionContent.style.height = height
      }, 0)

      /** Slide up. */
    } else {
      /** Set the height as 0px to trigger the slide up animation. */
      accordionContent.style.height = '0px'

      /** Remove the `active` class when the animation ends. */
      accordionContent.addEventListener(
        'transitionend',
        () => {
          accordion.classList.remove('open')
        },
        { once: true }
      )
    }
  })
})

/*!
 * Serialize all form data into a SearchParams string
 * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var serialize = function (form) {
  var arr = []
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (
      !field.name ||
      field.disabled ||
      ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
    )
      return
    if (field.type === 'select-multiple') {
      var arrField = []
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return
        //arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value));
        arrField.push(encodeURIComponent(option.value))
      })
      if (typeof arrField !== 'undefined' && arrField.length > 0) {
        arr.push(encodeURIComponent(field.name) + '=' + arrField.toString())
      }
      return
    }
    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return
    arr.push(
      encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
    )
  })
  return arr.join('&')
}

const filters = document.querySelectorAll('.muli-select-filter')
if (filters) {
  const loadArchive = document.querySelector('.load-archive')
  const loadArchiveBtn = document.querySelector('#pagination-btn a')
  filters.forEach((filter) => {
    const uiFilter = filter.parentElement

    const choices = new Choices(filter, {
      placeholder: true,
      removeItemButton: true,
      itemSelectText: '',
      renderSelectedChoices: 'always',
      callbackOnCreateTemplates: () => ({
        input: (...args) =>
          Object.assign(Choices.defaults.templates.input.call(this, ...args), {
            readOnly: true,
          }),
      }),
    })

    filter.addEventListener(
      'addItem',
      (event) => {
        // do something creative here...
        const mobileResults = document.querySelector('.mobile-results')
        const tag = document.createElement('DIV')
        const tagBtn = document.createElement('BUTTON')

        tag.value = event.detail.value
        tag.setAttribute(
          'id',
          filter.name + '-' + event.detail.value + '-' + event.detail.id
        )
        tag.className = filter.name
        tag.innerText = event.detail.label
        tag.appendChild(tagBtn)

        mobileResults.appendChild(tag)
        tagBtn.addEventListener('click', () => {
          var newE = document.createEvent('HTMLEvents')
          newE.initEvent('mousedown', false, true)
          document
            .querySelector(
              '.choices__item[data-id="' + event.detail.id + '"] button'
            )
            .dispatchEvent(newE)
          mobileResults.removeChild(tag)
        })

        setTimeout(() => {
          document.activeElement.blur()
        }, 250)

        //filter.closest('.choices').blur();
      },
      false
    )

    filter.addEventListener(
      'removeItem',
      (e) => {
        const mobileResults = document.querySelector('.mobile-results')
        const removeItem = mobileResults.querySelector(
          '#' + filter.name + '-' + event.detail.value + '-' + event.detail.id
        )
        mobileResults.removeChild(removeItem)
      },
      false
    )

    const handleFilterChange = () => {
      let formData = serialize(document.getElementById('filters'))
      //filter.hideDropdown();
      const reportsWrap = document.getElementById('reports-wrap')
      reportsWrap.style.transition = 'opacity 0.5s'
      reportsWrap.style.opacity = 0

      axios.get(window.location.href + '?' + formData).then((res) => {
        const doc = document.createElement('div')
        doc.innerHTML = res.data
        const nextPageBtn = doc.querySelector('#pagination-btn a')
        if (nextPageBtn) {
          loadArchive.classList.remove('hidden')
          loadArchiveBtn.href = nextPageBtn.href
        } else {
          loadArchive.classList.add('hidden')
        }
        let filteredReports = doc.querySelector('#reports-wrap').innerHTML
        setTimeout(function () {
          reportsWrap.innerHTML = filteredReports
          // ajaxPagination();
          // fadeinImags();
          // window.scrollTo(window.scrollX, window.scrollY - 1);
          // window.scrollTo(window.scrollX, window.scrollY + 1);
          reportsWrap.removeAttribute('style')
        }, 500)
      })
    }
    filter.addEventListener('change', handleFilterChange)

    // Close dropdown on filter click
    const handleCloserClick = () => {
      choices.hideDropdown()
    }
    filter.addEventListener('showDropdown', () => {
      setTimeout(() => {
        if (uiFilter) {
          uiFilter.addEventListener('click', handleCloserClick)
          const selectedDropdownItems = uiFilter.querySelectorAll(
            '.choices__item.is-selected'
          )
          selectedDropdownItems.forEach((selectedDropdownItem) => {
            // Clicks on activated filters in dropdown should remove them
            selectedDropdownItem.addEventListener('mousedown', (event) => {
              choices.removeActiveItemsByValue(
                event.currentTarget.dataset.value
              )
              choices.hideDropdown()
              handleFilterChange()
            })
          })
        }
      }, 100)
    })
    filter.addEventListener('hideDropdown', () => {
      if (uiFilter) {
        uiFilter.removeEventListener('click', handleCloserClick)
      }
    })

    if (uiFilter) {
      uiFilter.addEventListener('click', (event) => {
        const choicesEl = event.currentTarget.parentElement
        if (choicesEl && choicesEl.classList.contains('is-open')) {
          choices.hideDropdown()
        }
      })
    }
  })
}

var textarea = document.querySelector('textarea')
if (textarea) {
  textarea.addEventListener('keydown', autosize)
}

function autosize() {
  var el = this
  setTimeout(function () {
    el.style.cssText = 'height:auto; padding:.5em'
    // for box-sizing other than "content-box" use:
    // el.style.cssText = '-moz-box-sizing:content-box';
    el.style.cssText = 'height:' + el.scrollHeight + 'px'
  }, 0)
}

const homeSlider = document.querySelector('.home-slider')
if (homeSlider) {
  let autoplay = false
  let autoplaySpeed = 3000
  if (homeSlider.dataset.delay !== '') {
    const delay = parseInt(homeSlider.dataset.delay, 10)
    if (delay > 0) {
      autoplay = true
      autoplaySpeed = delay * 1000
    }
  }
  $('.home-slider .swiper-wrapper').slick({
    appendDots: '.home-slider .swiper-pagination',
    autoplay,
    autoplaySpeed,
    dots: true,
    nextArrow: '.home-slider .swiper-button-next',
    prevArrow: '.home-slider .swiper-button-prev',
  })
}

const boxesSlider = document.querySelector(
  '.page-template-template-coqual-summit .boxes-phone'
)
if (boxesSlider) {
  $('.page-template-template-coqual-summit .boxes-phone .swiper-wrapper').slick(
    {
      appendDots: '.boxes-phone .swiper-pagination',
      dots: true,
    }
  )
}

$('.more-reports-slider .swiper-wrapper').slick({
  nextArrow: '.more-reports-slider .swiper-button-next',
  prevArrow: '.more-reports-slider .swiper-button-prev',
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
  slidesToShow: 3,
})

$('.logo-slider .swiper-wrapper').slick({
  autoplay: true,
  disableOnInteraction: false,
  fade: true,
})

$('.summit-sessions-slider .swiper-wrapper').slick({
  nextArrow: '.summit-sessions-slider-wrap .swiper-button-next',
  prevArrow: '.summit-sessions-slider-wrap .swiper-button-prev',
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
  slidesToShow: 3,
})

// const menuItems = document.querySelectorAll('.slideout-menu .main-menu a');
// menuItems.forEach((menuItem)=>{
//     menuItem.addEventListener('mouseover', (e)=> {
//         if(menuItem.parentElement.classList.contains('has-children')){
//             if(!menuItem.classList.contains('submenu-open')){
//                 document.querySelectorAll('.has-children').forEach((hasChildren)=>{
//                     hasChildren.classList.remove('submenu-open');
//                 });
//                 menuItem.parentElement.classList.add('submenu-open');
//             }
//         }else{
//             document.querySelectorAll('.has-children').forEach((hasChildren)=>{
//                 hasChildren.classList.remove('submenu-open');
//             });
//         }
//     });
// });
// parents.forEach((parent)=>{
//     parent.addEventListener('mouseover', (e)=> {
//         e.preventDefault();
//         const navItem = this;
//         if(window.innerWidth > 750){
//             const headerWrap = document.querySelector('.header-wrap');
//             if(!parent.classList.contains('open')){
//                 parent.classList.add('open');
//                 const subNav = parent.parentElement.querySelector('ul');
//                 const subNavCln = subNav.cloneNode(true);
//                 headerWrap.appendChild(subNavCln);
//                 setTimeout(()=>{
//                 //     //subNavCln.classList.add('open');
//                 // //window.requestAnimationFrame(() => {
//                     if (document.contains(subNavCln)) {
//                         document.body.classList.add('submenu-open');
//                         const otherMenuItems = document.querySelectorAll('.slideout-menu .main-menu a:not(.open)');
//                         otherMenuItems.forEach((otherMenuItem)=>{
//                             otherMenuItem.addEventListener('mouseover', (e)=> {
//                                 parent.classList.remove('open');
//                                 //subNavCln.classList.remove('open');
//                                 document.body.classList.remove('submenu-open');
//                                 setTimeout(()=>{
//                                     headerWrap.removeChild(subNavCln);
//                                 },450);
//                             });
//                         });
//                     }
//                 },0);
//             }
//         }
//         // else{
//         //     parent.parentElement.classList.toggle('open');
//         // }
//     });
// });

function animateValue(obj, start, end, duration, suffix = '') {
  var range = end - start
  var current = start
  var increment = end > start ? 1 : -1
  var stepTime = Math.abs(Math.floor(duration / range))
  var timer = setInterval(function () {
    current += increment
    obj.innerHTML = current + suffix
    if (current == end) {
      clearInterval(timer)
    }
  }, stepTime)
}

// Graphs Numbers anims //
let observerCount = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const to = entry.target.dataset.to
      let isZeroedOut = true
      let suffix = ''
      let hasCommas = false
      if (to.indexOf(',') !== -1) {
        hasCommas = true
        const toComponents = to.split(',')
        toComponents.shift()
        toComponents.forEach((tc) => {
          if (parseInt(tc, 10) !== 0) {
            isZeroedOut = false
          }
        })
        suffix = ',' + toComponents.join(',')
      }
      if (to.indexOf('%') !== -1 && !hasCommas) {
        suffix += '%'
      }
      if (to.indexOf('+') !== -1 && !hasCommas) {
        suffix += '+'
      }
      if (!isZeroedOut) {
        return
      }
      const from = entry.target.dataset.from
      if (entry.target.classList.contains('was-animated')) {
        return
      }
      if (from === undefined || to === undefined) {
        return
      }
      if (entry.isIntersecting) {
        const fromInt = parseInt(entry.target.dataset.from, 10)
        let toInt = undefined
        if (to.indexOf(',') !== -1) {
          toInt = parseInt(to.split(',')[0], 10)
        } else {
          toInt = parseInt(entry.target.dataset.to, 10)
        }
        animateValue(entry.target, fromInt, toInt, 1000, suffix)
        entry.target.classList.add('was-animated')
      } else {
        entry.target.innerHTML = '0' + suffix
      }
    })
  },
  {
    //root: document.querySelector('.project-wrapper'),
    rootMargin: '0px 0px 0px 0px',
    threshold: [1],
  }
)
document.querySelectorAll('.count-anim').forEach((countAnim) => {
  observerCount.observe(countAnim)
})

let observerChart = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('inview')
        setTimeout(() => {
          entry.target.classList.add('was-animated')
        }, 1500)
      } else {
        entry.target.classList.remove('inview')
      }
    })
  },
  {
    rootMargin: '0px 0px 0px 0px',
    threshold: [1],
  }
)
document.querySelectorAll('.bar-chart').forEach((barChart) => {
  observerChart.observe(barChart)
})
document.querySelectorAll('.bar-charts').forEach((barChartSlideEl) => {
  barChartSlideEl
    .querySelectorAll('.bar-charts-group-wrap')
    .forEach((bcgwEl) => {
      const barChartEls = bcgwEl.querySelectorAll('.bar-chart')
      if (barChartEls.length > 0) {
        const barWidth = barChartEls[0].getBoundingClientRect().width
        const numberOfBars = barChartEls.length
        const h4El = bcgwEl.querySelector('h4')
        if (h4El) {
          h4El.style.maxWidth = `${barWidth * 1.2 * numberOfBars}px`
        }
      }
    })
  setTimeout(() => {
    let tallestH4 = 0
    barChartSlideEl.querySelectorAll('h4').forEach((h4El) => {
      const height = h4El.getBoundingClientRect().height
      if (height > tallestH4) {
        tallestH4 = height
      }
    })
    barChartSlideEl.querySelectorAll('h4').forEach((h4El) => {
      h4El.style.height = `${tallestH4}px`
    })
  }, 10)
})
// function getElementY(query) {
//     return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
// }

// function doScrolling(element, duration) {
//     let startingY = window.pageYOffset
//     let elementY = getElementY(element)
//     // If element is close to page's bottom then window will scroll only to some position above the element.
//     let targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
//         let diff = targetY - startingY
//     // Easing function: easeInOutCubic
//     // From: https://gist.github.com/gre/1650294
//     let easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
//     let start

//     if (!diff) return

//         // Bootstrap our animation - it will get called right before next frame shall be rendered.
//         window.requestAnimationFrame(function step(timestamp) {
//         if (!start) start = timestamp
//         // Elapsed miliseconds since start of scrolling.
//         let time = timestamp - start
//             // Get percent of completion in range [0, 1].
//         let percent = Math.min(time / duration, 1)
//         // Apply the easing.
//         // It can cause bad-looking slow frames in browser performance tool, so be careful.
//         percent = easing(percent)

//         window.scrollTo(0, startingY + diff * percent)

//             // Proceed with animation as long as we wanted it to.
//         if (time < duration) {
//         window.requestAnimationFrame(step)
//         }
//     })
// }

document.addEventListener(
  'wpcf7mailsent',
  function () {
    const offsetTop =
      document.querySelector('.wpcf7').offsetTop +
      document.querySelector('.header-wrap').getBoundingClientRect.height
    window.scrollTo({ top: offsetTop, behavior: 'smooth' })
    //doScrolling.bind(null, 'form.wpcf7', 1000);
  },
  false
)

// Selects //
/**
 * Get siblings of an element
 * @param  {Element} elem
 * @return {Object}
 */
var getSiblings = function (elem) {
  var siblings = []
  var sibling = elem.parentNode.firstChild
  var skipMe = elem
  for (; sibling; sibling = sibling.nextSibling)
    if (sibling.nodeType == 1 && sibling != elem) siblings.push(sibling)
  return siblings
}
var x, i, j, selElmnt, a, b, c
/*look for any elements with the class "custom-select":*/
//x = document.getElementsByClassName("custom-select");
x = document.querySelectorAll('.wpcf7 select')
if (x) {
  for (i = 0; i < x.length; i++) {
    //selElmnt = x[i].getElementsByTagName("select")[0];
    selElmnt = x[i]
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement('DIV')
    a.setAttribute('class', 'select-selected')
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
    //x[i].appendChild(a);
    selElmnt.parentElement.classList.add('custom-select')
    selElmnt.parentElement.appendChild(a)
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement('DIV')
    b.setAttribute('class', 'select-items select-hide')
    // let start = 0;
    // if(selElmnt.closest('.filters')){
    //     let start = 1;
    // }
    for (j = 1; j < selElmnt.length; j++) {
      /*for each option in the original select element,
                create a new DIV that will act as an option item:*/
      c = document.createElement('DIV')
      c.innerHTML = selElmnt.options[j].innerHTML
      c.addEventListener('click', function (e) {
        /*when an item is clicked, update the original select box,
                        and the selected item:*/
        var i, s, h
        s = this.parentNode.parentNode.getElementsByTagName('select')[0]
        h = this.parentNode.previousSibling
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i
            h.innerHTML = this.innerHTML
            // if (h.innerHTML.length) {
            //     selectLabelFocus(this);
            // }
            break
          }
        }
        h.click()

        s.dispatchEvent(new Event('change'))
      })
      b.appendChild(c)
    }
    //x[i].appendChild(b);
    selElmnt.parentElement.appendChild(b)
    a.addEventListener('click', function (e) {
      /*when the select box is clicked, close any other select boxes,
                and open/close the current select box:*/
      e.stopPropagation()
      closeAllSelect(this)
      this.parentElement.classList.add('open')
      let sibs = getSiblings(this.parentElement)
      for (i = 0; i < sibs.length; i++) {
        sibs[i].classList.remove('open')
        let openArr = sibs[i].querySelector('.select-arrow-active')
        if (openArr) {
          openArr.classList.remove('select-arrow-active')
          openArr.nextSibling.classList.add('select-hide')
        }
      }

      this.nextSibling.classList.toggle('select-hide')
      this.classList.toggle('select-arrow-active')
    })
  }
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
      except the current select box:*/
  var x,
    y,
    i,
    arrNo = []
  x = document.getElementsByClassName('select-items')
  y = document.getElementsByClassName('select-selected')
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove('select-arrow-active')
    }
    y[i].parentElement.classList.remove('open')
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('select-hide')
    }
  }
  //selectLabelBlur(x);
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener('click', closeAllSelect)

// function fetch(){
//     axios({
//         method: 'post',
//         url: sitevars.ajaxurl,
//         data: {
//             action: 'ajax_search',
//             keyword: document.getElementById('search').value
//         }
//     }).then(function(response){
//         document.querySelector('#search-results').innerHTML = response;
//     });
// }

// document.getElementById('search').addEventListener('submit', ()=>{
//     fetch();
// });

document.getElementById('search-form').addEventListener(
  'submit',
  (e) => {
    e.preventDefault()
    const searchVal = document.getElementById('search').value
    const searchAction = document.getElementById('search-form').action
    const searchResults = document.getElementById('search-results')
    const searchPrompt = document.querySelector(
      '.search-form label.without-results'
    )
    const searchResultsIndicator = document.querySelector(
      '.search-form label.with-results'
    )
    searchResults.style.transition = 'opacity 0.5s'
    searchResults.style.opacity = 0
    axios.get(searchAction + '?s=' + searchVal).then((res) => {
      const doc = document.createElement('div')
      doc.innerHTML = res.data
      let filteredReports = doc.querySelector('#search-results').innerHTML
      const numberOfResults = doc.querySelectorAll('.search-result').length
      searchResultsIndicator.querySelector('span').innerHTML = numberOfResults
      searchResults.classList.add('has-results')
      searchPrompt.classList.add('hide')
      searchResultsIndicator.classList.add('show')
      setTimeout(function () {
        searchResults.innerHTML = filteredReports
        // ajaxPagination();
        // fadeinImags();
        // window.scrollTo(window.scrollX, window.scrollY - 1);
        // window.scrollTo(window.scrollX, window.scrollY + 1);
        searchResults.removeAttribute('style')
      }, 500)
    })
  },
  false
)

// Events Fitlers //
const eventsFilters = document.querySelectorAll('.event-filter')
if (eventsFilters) {
  eventsFilters.forEach((eventsFilter) => {
    eventsFilter.addEventListener(
      'click',
      (e) => {
        e.preventDefault()
        const eventsWrap = document.getElementById('events-ajax-wrapper')
        if (eventsWrap) {
          eventsWrap.style.transition = 'opacity 0.5s'
          eventsWrap.style.opacity = 0
        }
        axios.get(eventsFilter.href).then((res) => {
          const doc = document.createElement('div')
          doc.innerHTML = res.data
          let filteredReports = doc.querySelector(
            '#events-ajax-wrapper'
          ).innerHTML
          setTimeout(function () {
            eventsWrap.innerHTML = filteredReports
            // fadeinImags();
            // window.scrollTo(window.scrollX, window.scrollY - 1);
            // window.scrollTo(window.scrollX, window.scrollY + 1);
            ajaxPagination()
            eventsWrap.removeAttribute('style')
            MediaBox('.popup-video')
          }, 500)
        })
      },
      false
    )
  })
}

const videoPlayBtns = document.querySelectorAll('.inline-video-play')
if (videoPlayBtns) {
  videoPlayBtns.forEach((videoPlayBtn) => {
    videoPlayBtn.addEventListener('click', () => {
      const vidWrap = videoPlayBtn.parentElement
      const vidElm = vidWrap.querySelector('video')
      if (vidWrap.classList.contains('paused')) {
        vidWrap.classList.add('playing')
        vidWrap.classList.remove('paused')
        vidElm.play()
      } else {
        vidWrap.classList.remove('playing')
        vidWrap.classList.add('paused')
        vidElm.pause()
      }
    })
  })
}
const fullscreen = document.querySelector('.fullscreen-video')
if (fullscreen) {
  fullscreen.addEventListener('click', () => {
    const vidWrap = fullscreen.parentElement
    const vidElm = vidWrap.querySelector('video')
    if (vidElm.requestFullscreen) {
      vidElm.requestFullscreen()
    } else if (vidElm.msRequestFullscreen) {
      vidElm.msRequestFullscreen()
    } else if (vidElm.mozRequestFullScreen) {
      vidElm.mozRequestFullScreen()
    } else if (vidElm.webkitRequestFullScreen) {
      vidElm.webkitRequestFullScreen()
    }
    vidElm.play()
    vidWrap.classList.add('playing')
    vidWrap.classList.remove('paused')
  })
}

function coqualFadeOut(el, callback) {
  el.style.opacity = 1
  ;(function fade() {
    if ((el.style.opacity -= 0.1) < 0) {
      el.style.display = 'none'
      if (callback) callback()
    } else {
      requestAnimationFrame(fade)
    }
  })()
}

function ajaxPagination() {
  // loadArchive is the container for the pagination button on /our-research
  // and /members/research. We need to hide it at the same time as pageBtn.
  const loadArchive = document.querySelector('.load-archive')
  const pageBtn = document.querySelector('#pagination-btn a')
  const pageCont = document.querySelector('.pagination-content')
  if (pageBtn) {
    pageBtn.addEventListener('click', function (event) {
      event.preventDefault()
      if (!pageBtn.classList.contains('loading-pages')) {
        pageBtn.classList.add('loading-pages')
        let pageUrl = this.href
        axios.get(pageUrl).then((res) => {
          const doc = document.createElement('div')
          doc.innerHTML = res.data
          const newPosts = doc.querySelectorAll(
            '.pagination-content .pagination-elem'
          )
          const nextPageBtn = doc.querySelector('#pagination-btn a')
          if (nextPageBtn) {
            pageBtn.href = nextPageBtn.href
            if (loadArchive) {
              loadArchive.classList.remove('hidden')
            }
          } else {
            // On pages with filters, we only want to hide the page button, not
            // remove it
            if (loadArchive) {
              loadArchive.classList.add('hidden')
            } else {
              pageBtn.parentNode.removeChild(pageBtn)
            }
          }
          // Look for separator cards in the incoming items and make an array
          // of their text contents
          const existingSeparatorCards = Array.from(
            document.querySelectorAll('.separator-card')
          ).map((separatorCardEl) => separatorCardEl.innerText.trim())
          let hasPopupVideos = false
          // Loop through new items
          newPosts.forEach(function (newPost) {
            // Is this a popup video?
            if (!hasPopupVideos && newPost.querySelector('.popup-video')) {
              hasPopupVideos = true
            }
            // Append all non-separator cards
            if (!newPost.classList.contains('separator-card')) {
              pageCont.appendChild(newPost)
            } else if (
              // If we have a separatar card, see if it already exists on the
              // page
              existingSeparatorCards.indexOf(newPost.innerText.trim()) === -1
            ) {
              // If it doesn't, append it
              pageCont.appendChild(newPost)
            }
          })
          // If popup videos came along in the load, call MediaBox on them
          if (hasPopupVideos) {
            MediaBox('.popup-video')
          }
          setTimeout(function () {
            pageBtn.classList.remove('loading-pages')
          }, 500)
        })
      }
    })
  }
}
ajaxPagination()

if (document.getElementById('close-note')) {
  document.getElementById('close-note').addEventListener('click', () => {
    document.body.classList.remove('has-header-note')
  })
}

const headerScroll = () => {
  if (window.scrollY > 50) {
    document.querySelector('.site-header').classList.add('compressed')
  } else {
    document.querySelector('.site-header').classList.remove('compressed')
  }
}

headerScroll()
window.addEventListener('scroll', headerScroll)

// Pie Chart ref: https://codepen.io/travishorn/pen/WmzmLz //
const pieChart = (selector, data, shouldAnimate) => {
  let half = 400 / 3
  if (window.innerWidth <= 750) {
    half = 400 / 2
  }
  const container = d3.select(selector)
  const chart = container
    .append('svg')
    .style('width', '100%')
    .attr('viewBox', '0 0 400 380')
  const plotArea = chart
    .append('g')
    .attr('class', 'plotarea')
    .attr('transform', 'translate(200, 200)')
  const pie = d3
    .pie()
    .sort(null)
    .value((d) => d.value)
  const arcs = pie(data)
  const arc = d3.arc().innerRadius(0).outerRadius(half)
  const arcLabel = d3
    .arc()
    .innerRadius(half)
    .outerRadius(half * 1.3)

  if (shouldAnimate && !selector.classList.contains('was-animated')) {
    selector.classList.add('was-animated')
    plotArea
      .selectAll('path')
      .data(arcs)
      .enter()
      .append('path')
      .attr('fill', (d) => d.data.color)
      .attr('stroke', 'black')
      .attr('vector-effect', 'non-scaling-stroke')
      .attr('stroke-width', 2)
      .attr('stroke', 'black')
      .transition()
      .delay(function (_d, i) {
        return i * 500
      })
      .duration(500)
      .attrTween('d', function (d) {
        var i = d3.interpolate(d.startAngle + 0.1, d.endAngle)
        return function (t) {
          d.endAngle = i(t)
          return arc(d)
        }
      })
  } else {
    plotArea
      .selectAll('path')
      .data(arcs)
      .enter()
      .append('path')
      .attr('fill', (d) => d.data.color)
      .attr('stroke', 'black')
      .attr('vector-effect', 'non-scaling-stroke')
      .attr('stroke-width', 2)
      .attr('stroke', 'black')
      .attr('d', arc)
  }
  const labels = plotArea.selectAll('text').data(arcs).enter().append('text')
  if (window.innerWidth <= 750) {
    labels.each(function (d) {
      const centroid = arc.centroid(d)
      d3.select(this)
        .attr('x', centroid[0])
        .attr('y', centroid[1])
        .attr('dx', '-0.75em')
        .attr('dy', '0.33em')
        .text(`${d.data.value}%`)
    })
  } else {
    labels.each(function (d) {
      const centroid = arcLabel.centroid(d)
      d3.select(this)
        .attr('x', centroid[0])
        .attr('y', centroid[1])
        .attr('dx', '-1em')
        .attr('dy', '0.33em')
        .text(`${d.data.value}%`)
    })
  }
}

// const pieChartEls = document.querySelectorAll('.pie-chart');
// if(pieChartEls){
//     pieChartEls.forEach((pieChartEl)=>{
//         pieChart(pieChartEl, JSON.parse(pieChartEl.dataset.piechart));
//     });
// }

const lineChart = (selector, data) => {
  // set the dimensions and margins of the graph
  var margin = { top: 10, right: 100, bottom: 30, left: 30 },
    width = 960 - margin.left - margin.right,
    height = 480 - margin.top - margin.bottom

  // append the svg object to the body of the page
  var svg = d3
    .select(selector)
    .append('svg')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .append('g')
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

  //Read the data
  //d3.csv("https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/data_connectedscatter.csv", function(data) {

  // List of groups (here I have one group per column)
  var allGroup = ['valueA', 'valueB', 'valueC']
  // Reformat the data: we need an array of arrays of {x, y} tuples
  var dataReady = allGroup.map(function (grpName) {
    // .map allows to do something for each element of the list
    return {
      name: grpName,
      values: data.map((d) => {
        return { time: d.time, value: +d[grpName] }
      }),
    }
  })

  // A color scale: one color for each group
  var myColor = d3.scaleOrdinal().domain(allGroup).range(d3.schemeSet2)

  // Add X axis --> it is a date format
  var x = d3.scaleLinear().domain([0, 10]).range([0, width])
  svg
    .append('g')
    .attr('transform', 'translate(0,' + height + ')')
    .call(d3.axisBottom(x))
    .call((svg) => svg.select('.domain').remove())
    .style('font-size', '20px')
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')

  // Add Y axis
  var y = d3.scaleLinear().domain([0, 20]).range([height, 0])
  svg
    .append('g')
    .call(d3.axisLeft(y))
    .style('font-size', '20px')
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')

  // gridlines in x axis function
  function make_x_gridlines() {
    return d3.axisBottom(x).ticks(10)
  }

  // gridlines in y axis function
  function make_y_gridlines() {
    return d3.axisLeft(y).ticks(10)
  }

  // add the X gridlines
  svg
    .append('g')
    .attr('class', 'grid')
    .attr('transform', 'translate(0,' + height + ')')
    .style('stroke-dasharray', '3, 3')
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')
    .call(make_x_gridlines().tickSize(-height).tickFormat(''))

  // add the Y gridlines
  svg
    .append('g')
    .attr('class', 'grid')
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')
    .call(make_y_gridlines().tickSize(-width).tickFormat(''))

  // Add the lines
  var line = d3
    .line()
    .x(function (d) {
      return x(+d.time)
    })
    .y(function (d) {
      return y(+d.value)
    })
  svg
    .selectAll('myLines')
    .data(dataReady)
    .enter()
    .append('path')
    .attr('d', function (d) {
      return line(d.values)
    })
    .attr('stroke', function (d) {
      return myColor(d.name)
    })
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')
    .style('fill', 'none')

  // Add the points
  svg
    // First we need to enter in a group
    .selectAll('myDots')
    .data(dataReady)
    .enter()
    .append('g')
    .style('fill', function (d) {
      return myColor(d.name)
    })
    // Second we need to enter in the 'values' part of this group
    .selectAll('myPoints')
    .data(function (d) {
      return d.values
    })
    .enter()
    .append('circle')
    .attr('cx', function (d) {
      return x(d.time)
    })
    .attr('cy', function (d) {
      return y(d.value)
    })
    .attr('r', 10)
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')
    .attr('stroke', 'black')

  // Add a legend at the end of each line
  svg
    .selectAll('myLabels')
    .data(dataReady)
    .enter()
    .append('g')
    .append('text')
    .datum(function (d) {
      return { name: d.name, value: d.values[d.values.length - 1] }
    }) // keep only the last value of each time series
    .attr('transform', function (d) {
      return 'translate(' + x(d.value.time) + ',' + y(d.value.value) + ')'
    }) // Put the text at the position of the last point
    .attr('x', 12) // shift the text a bit more right
    .text(function (d) {
      return d.name
    })
    .style('fill', function (d) {
      return myColor(d.name)
    })
    .style('font-size', 20)

  //})
}

const lineChartEls = document.querySelectorAll('.line-chart')
if (lineChartEls) {
  lineChartEls.forEach((lineChartEl) => {
    lineChart(lineChartEl, JSON.parse(lineChartEl.dataset.data))
  })
}

const dotChart = (selector, shouldAnimate) => {
  // set the dimensions and margins of the graph
  var margin = { top: 20, right: 10, bottom: 100, left: 140 },
    width = 960 - margin.left - margin.right,
    height = 480 - margin.top - margin.bottom
  // append the svg object to the body of the page
  var svg = d3
    .select(selector)
    .append('svg')
    .style('width', '100%')
    .attr('viewBox', `0 0 960 480`)
    // .attr("width", width + margin.left + margin.right)
    // .attr("height", height + margin.top + margin.bottom)
    //.attr("viewBox", "0 0 "+width+" "+ height)
    .append('g')
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
  //Read the data
  // d3.csv("https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/connectedscatter.csv",
  // // When reading the csv, I must format variables:
  // function(d){
  // return { date : d3.timeParse("%Y-%m-%d")(d.date), value : d.value }
  // },
  // Now I can use this dataset:
  const data = JSON.parse(selector.dataset.data)
  const xaxis = selector.dataset.xaxis
  const yaxis = selector.dataset.yaxis
  const dotColor = selector.dataset.dotcolor
  const xMax = selector.dataset.xmax
  const xMin = selector.dataset.xmin
  const verticalLines = selector.dataset.verticallines
  // let xMax = 0;
  // let xMin = data[0][xaxis];
  //let yMax = 0;
  let yArr = ['']
  data.forEach((d) => {
    // xMax = d[xaxis] > xMax ? d[xaxis] : xMax;
    // xMin = d[xaxis] < xMin ? d[xaxis] : xMin;
    yArr.push(d[yaxis])
    //yMax = d[yaxis] > yMax ? d[yaxis] : yMax;
  })

  // Add X axis --> it is a date format
  //var x = d3.scaleTime()
  //.domain(d3.extent(data, function(d) { return d.date; }))
  var x = d3.scaleLinear().domain([xMin, xMax]).range([0, width])
  svg
    .append('g')
    .attr('transform', 'translate(0,' + height + ')')
    .call(d3.axisBottom(x))
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')
    .style('font-size', '14px')
  // Add Y axis
  var y = d3.scalePoint().domain(yArr).range([height, 0])
  svg
    .append('g')
    .call(d3.axisLeft(y))
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')
    .style('font-size', '14px')
  // Add the line
  // svg.append("path")
  // .datum(data)
  // .attr("fill", "none")
  // .attr("stroke", "#69b3a2")
  // .attr("stroke-width", 1.5)
  // .attr("d", d3.line()
  //     .x(function(d) { return x(d.date) })
  //     .y(function(d) { return y(d.value) })
  //     )
  // Add the points

  // gridlines in x axis function
  function make_x_gridlines() {
    return d3.axisBottom(x).ticks(10)
  }

  // gridlines in y axis function
  function make_y_gridlines() {
    return d3.axisLeft(y).ticks(10)
  }

  // add the X gridlines
  if (verticalLines === 'yes') {
    svg
      .append('g')
      .attr('class', 'grid')
      .attr('transform', 'translate(0,' + height + ')')
      .style('stroke-dasharray', '3, 3')
      .attr('stroke-width', 2)
      .attr('vector-effect', 'non-scaling-stroke')
      .call(make_x_gridlines().tickSize(-height).tickFormat(''))
  }

  // add the Y gridlines
  svg
    .append('g')
    .attr('class', 'grid')
    .attr('stroke-width', 2)
    .attr('vector-effect', 'non-scaling-stroke')
    .call(make_y_gridlines().tickSize(-width).tickFormat(''))

  if (shouldAnimate && !selector.classList.contains('was-animated')) {
    selector.classList.add('was-animated')
    svg
      .append('g')
      .selectAll('dot')
      .data(data)
      .enter()
      .append('circle')
      .attr('cx', function (d) {
        return x(d[xaxis])
      })
      .attr('cy', height)
      .attr('r', 10)
      .attr('fill', dotColor)
      .attr('stroke', 'black')
      .attr('stroke-width', 2)
      .attr('vector-effect', 'non-scaling-stroke')
      .transition()
      .duration(1000)
      //.attr("cx", function(d) { return x(d[xaxis]) })
      .attr('cy', function (d) {
        return y(d[yaxis])
      })
  } else {
    svg
      .append('g')
      .selectAll('dot')
      .data(data)
      .enter()
      .append('circle')
      .attr('cx', function (d) {
        return x(d[xaxis])
      })
      .attr('cy', height)
      .attr('r', 10)
      .attr('fill', dotColor)
      .attr('stroke', 'black')
      .attr('stroke-width', 2)
      .attr('vector-effect', 'non-scaling-stroke')
      // .transition()
      // .duration(1000)
      //.attr("cx", function(d) { return x(d[xaxis]) })
      .attr('cy', function (d) {
        return y(d[yaxis])
      })
  }
  // x axis label //
  svg
    .append('text')
    .attr(
      'transform',
      'translate(' + width / 2 + ' ,' + (height + margin.top + 60) + ')'
    )
    .style('text-anchor', 'middle')
    .text(xaxis)

  // y axis label //
  svg
    .append('text')
    .attr('transform', 'rotate(-90)')
    .attr('y', 0 - margin.left)
    .attr('x', 0 - height / 2)
    .attr('dy', '1em')
    .style('text-anchor', 'middle')
    .text(yaxis)
}

const initChart = (slide, shouldAnimate) => {
  const pieChartEls = slide.querySelectorAll('.pie-chart')
  pieChartEls.forEach((pieChartEl) => {
    let pieChartSvg = pieChartEl.querySelector('svg')
    if (pieChartSvg) {
      pieChartSvg.remove()
    }
    pieChart(pieChartEl, JSON.parse(pieChartEl.dataset.piechart), shouldAnimate)
  })
  const dotChartEl = slide.querySelector('.dot-chart')
  if (dotChartEl) {
    let dotChartSvg = dotChartEl.querySelector('svg')
    if (dotChartSvg) {
      dotChartSvg.remove()
    }
    dotChart(dotChartEl, shouldAnimate)
  }
  if (shouldAnimate) {
    const counters = slide.querySelectorAll('.counter')
    counters.forEach((counter) => {
      if (!counter.classList.contains('was-animated')) {
        const to = counter.innerText
        animateValue(counter, 0, to, 1000)
        counter.classList.add('was-animated')
      }
    })
    const bars = slide.querySelectorAll('.track .bar')
    bars.forEach((bar) => {
      bar.style.height = bar.dataset.height
    })
  }
  const horizontalBarChartEl = slide.querySelector('.horizontal-bar-chart')
  if (horizontalBarChartEl && shouldAnimate) {
    const valueWraps = horizontalBarChartEl.querySelectorAll('.value-wrap')
    valueWraps.forEach((vr) => {
      vr.style.width = vr.dataset.width
    })
    horizontalBarChartEl.classList.remove('finished-animating')
    setTimeout(() => {
      horizontalBarChartEl.classList.add('finished-animating')
    }, 500)
    setTimeout(() => {
      horizontalBarChartEl.classList.add('was-animated')
    }, 1500)
  }
}

const infographicsSliderEl = document.querySelector('.infographics-slider')
if (infographicsSliderEl) {
  initChart(infographicsSliderEl, false)
  setTimeout(function () {
    $('.infographics-slider .swiper-wrapper')
      .on('init', (_event, slick) => {
        const firstSlideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                entry.isIntersecting &&
                !entry.target.classList.contains('was-initialized')
              ) {
                initChart(entry.target, true)
                entry.target.classList.add('was-initialized')
              }
            })
          },
          {
            threshold: 0.5,
          }
        )
        firstSlideObserver.observe(slick.$slides[0])
      })
      .slick({
        adaptiveHeight: true,
        appendDots: '.infographics-slider .swiper-pagination',
        dots: true,
        nextArrow: '.infographics-slider .swiper-button-next',
        prevArrow: '.infographics-slider .swiper-button-prev',
      })
      .on('beforeChange', (_event, slick, currentSlide) => {
        const finishedAnimatingEl = slick.$slides[currentSlide].querySelector(
          '.finished-animating'
        )
        if (finishedAnimatingEl) {
          finishedAnimatingEl.classList.remove('finished-animating')
        }
      })
      .on('afterChange', (_event, slick, currentSlide) => {
        const currentSlideEl = slick.$slides[currentSlide]
        initChart(currentSlideEl, true)
      })
  }, 500)
}

// This is a hack to position the "This email is already in use" error message
// correctly depending on if the Submit button is visible or not
const registerForm = document.querySelector('body.register .wpcf7-form')
if (registerForm) {
  const pinInput = registerForm.querySelector('input[name="pin"]')
  const submitButton = registerForm.querySelector('input[type="submit"]')
  if (pinInput && submitButton) {
    pinInput.addEventListener('keydown', () => {
      setTimeout(() => {
        if (submitButton.parentElement.style.display === 'block') {
          registerForm.classList.add('submit-button-is-visible')
        } else {
          registerForm.classList.remove('submit-button-is-visible')
        }
      }, 500)
    })
  }
}

const givingForm = document.querySelector('.giving-form')
if (givingForm) {
  const setupForm = () => {
    if (!givingForm.classList.contains('setup-done')) {
      const recurringCheckbox = document.getElementById('recurring')
      if (recurringCheckbox) {
        recurringCheckbox.addEventListener('click', (event) => {
          if (event.target.classList.contains('is-selected')) {
            event.target.classList.remove('is-selected')
          } else {
            event.target.classList.add('is-selected')
          }
        })
      }

      const paymentRadios = document.querySelectorAll(
        '.giving-form .payment input[type="radio"]'
      )
      if (paymentRadios.length > 0) {
        const creditCard = document.getElementById('CreditCard')
        if (creditCard) {
          creditCard.classList.add('is-selected')
        }
        const handlePaymentRadioClick = (event) => {
          event.target.classList.add('is-selected')
          for (const paymentRadio of paymentRadios) {
            if (event.target.id !== paymentRadio.id) {
              paymentRadio.classList.remove('is-selected')
            }
          }
        }
        for (const paymentRadio of paymentRadios) {
          paymentRadio.addEventListener('click', handlePaymentRadioClick)
        }
      }

      const trueImpactCheckbox = document.getElementById('true-impact')
      if (trueImpactCheckbox) {
        trueImpactCheckbox.addEventListener('click', (event) => {
          if (event.target.classList.contains('is-selected')) {
            event.target.classList.remove('is-selected')
          } else {
            event.target.classList.add('is-selected')
          }
        })
      }

      givingForm.classList.add('setup-done')
    }
  }
  const observer = new MutationObserver((mutations) => {
    if (mutations.length > 0) {
      setupForm()
    }
  })
  observer.observe(givingForm, {
    childList: true,
  })
}
